<div class="image-control-wrapper d-flex align-items-center">
  <button class="btn d-flex align-items-center" type="button" (click)="downloadImage(fileInput)">
    <mat-icon>image</mat-icon>
    {{ btnLabel }}
  </button>

  <div 
    class="image-preview-wrapper position-relative" [style]="{ 'width': imageWrapperWith, 'height': imageWrapperHeight }">
      <img 
        class="image-preview"
        [src]="imagePreview"
        [alt]="imageAlt"
        [ngClass]="{
          'show-image': isShowImage,
          'hide-image': !isShowImage || errorMessage 
        }"
      >
      
      <button 
        *ngIf="isRemoveImageBtnVisible"
        class="image-remove-btn text-danger position-absolute top-0 start-100 translate-middle" 
        (click)="removeImage(fileInput)" 
        [ngClass]="{
          'show-image': isShowImage,
          'hide-image': !isShowImage || errorMessage 
        }"
      >
        <mat-icon>cancel</mat-icon>
      </button>
  </div>

  <input type="file" accept="image/*" #fileInput hidden (change)="onFileSelected($event)">

  <ng-container *ngIf="errorMessage">
    <p class="error-message m-0 text-danger">{{ '*' + errorMessage }}</p>
  </ng-container>
</div>